/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DiscountType = 0 | 1 | 2;

export const DiscountType = {

    NUMBER_0: 0 as DiscountType,

    NUMBER_1: 1 as DiscountType,

    NUMBER_2: 2 as DiscountType
};

